import { Extension } from '@tiptap/react';

export type TextAlignment = 'left' | 'center' | 'right';

export const ALIGNABLE_NODES = ['paragraph', 'heading'] as const;

const CLASS_BY_ALIGNMENT: Record<Exclude<TextAlignment, 'left'>, string> = {
    center: 'text-center',
    right: 'text-right',
};

const alignmentFromClass = (className: string | null): TextAlignment => {
    if (className === CLASS_BY_ALIGNMENT.center) return 'center';
    if (className === CLASS_BY_ALIGNMENT.right) return 'right';
    return 'left';
};

export const TextAlignClass = Extension.create({
    name: 'textAlignClass',
    addGlobalAttributes() {
        return [
            {
                types: [...ALIGNABLE_NODES],
                attributes: {
                    textAlign: {
                        default: 'left',
                        parseHTML: (element) => alignmentFromClass(element.getAttribute('class')),
                        renderHTML: (attributes) => {
                            const alignment = attributes.textAlign as TextAlignment;
                            return alignment === 'left' ? {} : { class: CLASS_BY_ALIGNMENT[alignment] };
                        },
                    },
                },
            },
        ];
    },
});
